import Base from "./_BaseComponent";
import $ from "jquery";

class Header extends Base.Component {
	private btnToggleMenu: JQuery<HTMLElement>;
	private lastTime: number;

	public onMount(): void {
		this.lastTime = 0;
		this.btnToggleMenu = this.element.find("[data-toggle-menu]");
		if (this.btnToggleMenu)
			this.btnToggleMenu.on(
				"click touchstart",
				this.toggleMenu.bind(this)
			);


		this.element.find("li.menu-item-has-children a").on("click",
			this.openSubMenu);

	}

	private openSubMenu(e: any) {
		const parent = $(e.currentTarget).parent("li");
		const sub = $(parent).find("ul.sub-menu");
		if (! sub || sub.length < 1)
			return;

		e.preventDefault();
		$(sub).toggleClass("open");
	}

	private toggleMenu(): void {
		const now = new Date().getTime();
		if (now - this.lastTime < 500) return;

		this.element.toggleClass("menu-active");
		this.lastTime = now;
	}
}

export default Base.Init("[data-component-header]", Header);
